export default __webpack_public_path__ + "static/media/circles.0daf7648.svg";